// extracted by mini-css-extract-plugin
export default {"range":"inputRange_range__eWLWg","inputNumber":"inputRange_inputNumber__roBGN"};